import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { FONTS, SPACES } from 'src/constants'

const useStyles = makeStyles((theme: Theme) => ({
  filterWrapper: {
    '&&': {
      marginBottom: SPACES.xxl,
    },
  },
  searchBarWrapper: {
    '&&': {
      display: 'flex',
      gap: 10,
      [theme.breakpoints.down('laptop_l')]: {
        marginBottom: SPACES.xxl,

        width: 230,
        height: 40,
      },

      [theme.breakpoints.up('laptop_l')]: {
        marginBottom: SPACES.xxxl,

        width: 406,
        height: 40,
      },
    },
  },

  sortSelectWrapper: {
    '&&': {
      height: 14,
      color: theme.palette.custom.darkBlue2,
    },

    '& .MuiSelect-select': {
      fontWeight: FONTS.WEIGHTS.bold,
      fontSize: FONTS.SIZES.xs,
      lineHeight: 1.4,
    },
  },
  sortSelectOption: {
    '&&': {
      padding: SPACES.xxxs,
      fontWeight: FONTS.WEIGHTS.light,
      fontSize: FONTS.SIZES.xs,
      lineHeight: 1.33,
      color: theme.palette.custom.darkBlue2,
    },
  },
  filterText: {
    '&&': {
      fontWeight: FONTS.WEIGHTS.bold,
      fontSize: FONTS.SIZES.xs,
      lineHeight: 1.4,

      cursor: 'pointer',
      color: theme.palette.custom.black,
    },
  },
  button: {
    border: `1px solid ${theme.palette.custom.grey3}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 40,
    minWidth: 40,
    borderRadius: '50%',
    cursor: 'pointer',
    '&&:hover': {
      border: `1px solid ${theme.palette.custom.darkBlue2}`,
    },

    '&&:active': {
      border: `1px solid ${theme.palette.primary.main}`,
    },
  },
  filterIcon: {
    '&&': {
      padding: 1,

      display: 'flex',
      gap: SPACES.xs,
    },
  },
  selectionContainer: {
    [theme.breakpoints.down('laptop_l')]: {
      marginBottom: SPACES.xxl,
    },
  },
  selectionOptionsWrapper: {
    '&&': {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'flex-start',

      [theme.breakpoints.down('laptop_l')]: {
        gap: SPACES.xxs,
      },
      [theme.breakpoints.up('laptop_l')]: {
        gap: SPACES.xl,
      },
    },
  },
  selectionOptionsFormControl: {
    '&&': {
      [theme.breakpoints.down('laptop_l')]: {
        minWidth: 163,
      },
      [theme.breakpoints.up('laptop_l')]: {
        minWidth: 194,
      },
    },
  },
  formSelect: {
    '&&': {
      paddingLeft: SPACES.xxl,
      paddingRight: SPACES.xl,

      border: `1px solid ${theme.palette.custom.grey}`,
      borderRadius: '30px',

      fontWeight: FONTS.WEIGHTS.bold,
      fontSize: FONTS.SIZES.s,
      textTransform: 'uppercase',
      color: theme.palette.custom.darkBlue2,

      [theme.breakpoints.down('laptop_l')]: {
        height: 40,
      },
      [theme.breakpoints.up('laptop_l')]: {
        height: 40,
      },
    },
  },
  selectLabel: {
    '&&': {
      fontWeight: FONTS.WEIGHTS.bold,
      fontSize: FONTS.SIZES.s,
      lineHeight: 1.33,
      textTransform: 'initial',

      color: theme.palette.custom.grey2,

      '&:first-letter': {
        textTransform: 'uppercase',
      },
    },
  },
  selectItem: {
    '&&': {
      fontWeight: FONTS.WEIGHTS.bold,
      fontSize: FONTS.SIZES.s,
      lineHeight: 1.33,
      textTransform: 'uppercase',

      color: theme.palette.custom.darkBlue2,
    },
  },
  formCheckbox: {
    '&&': {
      border: `1px solid ${theme.palette.custom.grey2}`,
      borderRadius: '3px',
    },
  },
  formCheckboxText: {
    '&&': {
      fontWeight: FONTS.WEIGHTS.bold,
      fontSize: FONTS.SIZES.s,
      lineHeight: 1.33,

      color: theme.palette.custom.grey2,
    },
  },
  checkboxSt: {
    '&&': {
      color: theme.palette.custom.grey2,
      '&.Mui-checked': {
        color: theme.palette.custom.grey2,
      },
    },
  },
}))

export default useStyles
